import React, { Component } from 'react';
import { MARKETING_MODAL, PAYROLL_MODAL } from '../../redux/reducers/modal';
import EmailSubscriptionsContent from '../blocks/email_subscriptions/EmailSubscriptionsContent';
import MarketingStatsModal from '../blocks/marketing/MarketingStatsModal';
import ReduxModal from '../blocks/modal/ReduxModal';
import MainNav from '../blocks/navigation/MainNav';
import PayrollGeneratorModal from '../blocks/payroll/PayrollGeneratorModal';
import type { EmailSubscriptionsProps } from '../../types';

class EmailSubscriptions extends Component<EmailSubscriptionsProps> {
  handlePayrollGeneratorClick = () => {
    const { onOpenModal } = this.props;
    onOpenModal({ id: PAYROLL_MODAL });
  };

  handlePayrollModalClose = () => {
    const { onCloseModal } = this.props;
    onCloseModal({ id: PAYROLL_MODAL });
  };

  handleMarketingStatsClick = () => {
    const { onOpenModal } = this.props;
    onOpenModal({ id: MARKETING_MODAL });
  };

  handleMarketingModalClose = () => {
    const { onCloseModal } = this.props;
    onCloseModal({ id: MARKETING_MODAL });
  };

  render(): React.ReactNode {
    const { currentUser, router, onUpdateEmailSubscriptions } = this.props;

    return (
      <div className="container-view vacation-management-view view-wrapper has-custom-table">
        <MainNav
          currentUser={currentUser}
          navigate={router.navigate}
          onPayrollGeneratorClick={this.handlePayrollGeneratorClick}
          onMarketingStatsClick={this.handleMarketingStatsClick}
        />
        <EmailSubscriptionsContent
          {...this.props}
          onUpdateEmailSubscriptions={onUpdateEmailSubscriptions}
        />
        <ReduxModal id={PAYROLL_MODAL}>
          <PayrollGeneratorModal
            onCloseModal={this.handlePayrollModalClose}
          />
        </ReduxModal>
        <ReduxModal id={MARKETING_MODAL}>
          <MarketingStatsModal
            onCloseModal={this.handleMarketingModalClose}
          />
        </ReduxModal>
      </div>
    );
  }
}

export default EmailSubscriptions;
